import { createFileRoute } from "@tanstack/react-router";
import BranchesConfigurations from "@/components/branches/branches-configuration";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/branches",
)({
  component: BranchesPage,
});

function BranchesPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "branches", actions: ["read", "update"] }]}
    >
      <BranchesConfigurations module="branches" />
    </RouteGuardPermissions>
  );
}
